import SchemaService from 'services/schema';

const { gtag } = window;

// Maps the legacy action labels to GA4 event names (snake_case).
const GA4_BREADCRUMB_EVENTS = {
  'Abrir Grupo': 'breadcrumb_open_group',
  'Selecionar Grupo': 'breadcrumb_select_group',
  'Abrir Breadcrumb': 'breadcrumb_open',
  'Fechar Breadcrumb': 'breadcrumb_close',
};

export const callGtag = (action, user_id, business_id, group_id) => {
  if (typeof gtag !== 'function') return;
  gtag('event', GA4_BREADCRUMB_EVENTS[action] ?? 'breadcrumb_action', {
    user_id,
    business_id,
    group_id: group_id ?? undefined,
  });
};

export async function getParents(id) {
  try {
    const parents = await SchemaService.getParents(id);
    return parents.data;
  } catch (e) {
    return [];
  }
}

export async function getChildGroups(id) {
  try {
    const childGroups = await SchemaService.getChildGroups(id);
    return childGroups.data;
  } catch (e) {
    return [];
  }
}
